export default __webpack_public_path__ + "locales/it/ChangePhoneDialog.json?hash=6efead08ee67672b7fe8ebb571953deb";